// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!./MapButtons.module.css");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../../assets/images/button_icons/review_heart.svg");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kEzlbZE8XlLEgVDD62Us {
    --icon-background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    --icon-background-size: 21px;
}

.Th5_rx7p1Klhq3wa9ELE {
    display: none;
}

.AGE2DgjFL9f4t36JwFGr {
}

.ObMsOZEvWpl64gpEUVmN {
}

.QuTJH2RoH9JhAaU2tCbu {
}

.CFzlBte8c0pPT6Hy8W2A {
}

.Uggw6ndZQM1FN8r7TbLF {
}

.neA44Gr8J0ZiFcI37grC {
}

.LNoVV0vHVith5saxF5wX {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 1rem 0;
    gap: 1rem;
    width: 100%;
    box-sizing: border-box;
}

.LNoVV0vHVith5saxF5wX p {
    font-size: var(--map-small-body-font-size);
}

.aJUdQ_b3j1zIkrqmgLPw .LNoVV0vHVith5saxF5wX:first-of-type {
  padding-top: 0.25rem;
}

.aJUdQ_b3j1zIkrqmgLPw .LNoVV0vHVith5saxF5wX + .LNoVV0vHVith5saxF5wX {
    border-top: 1px solid rgba(0,0,0,0.12);
    margin-top: 0; /* keep spacing controlled by padding */
}

.LNoVV0vHVith5saxF5wX:last-of-type {
    padding-bottom: 0;
}`, "",{"version":3,"sources":["webpack://./../core/components/map-buttons/LeaveReviewButton.module.css"],"names":[],"mappings":"AAAA;IAEI,gEAAqE;IACrE,4BAA4B;AAChC;;AAEA;IACI,aAAa;AACjB;;AAEA;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,eAAe;IACf,SAAS;IACT,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;EACE,oBAAoB;AACtB;;AAEA;IACI,sCAAsC;IACtC,aAAa,EAAE,uCAAuC;AAC1D;;AAEA;IACI,iBAAiB;AACrB","sourcesContent":[".leaveReviewIcon {\r\n    composes: mapButtonIcon from './MapButtons.module.css';\r\n    --icon-background-image: url('@images/button_icons/review_heart.svg');\r\n    --icon-background-size: 21px;\r\n}\r\n\r\n.hidden {\r\n    display: none;\r\n}\r\n\r\n.supportInfoContainer {\r\n    composes: mapContentContainer from './MapButtons.module.css';\r\n}\r\n\r\n.supportHeaderContainer {\r\n    composes: mapButtonHeaderContainer from './MapButtons.module.css';\r\n}\r\n\r\n.supportHeader {\r\n    composes: mapButtonHeader from './MapButtons.module.css';\r\n}\r\n\r\n.closeIcon {\r\n    composes: closeIcon from './MapButtons.module.css';\r\n}\r\n\r\n.supportInfoContentContainer {\r\n    composes: mapButtonContentContainer from './MapButtons.module.css';\r\n}\r\n\r\n.supportInfoContent {\r\n    composes: mapButtonContent from './MapButtons.module.css';\r\n}\r\n\r\n.supportItem {\r\n    display: flex;\r\n    justify-content: flex-start;\r\n    align-items: center;\r\n    padding: 1rem 0;\r\n    gap: 1rem;\r\n    width: 100%;\r\n    box-sizing: border-box;\r\n}\r\n\r\n.supportItem p {\r\n    font-size: var(--map-small-body-font-size);\r\n}\r\n\r\n.supportItemsContainer .supportItem:first-of-type {\r\n  padding-top: 0.25rem;\r\n}\r\n\r\n.supportItemsContainer .supportItem + .supportItem {\r\n    border-top: 1px solid rgba(0,0,0,0.12);\r\n    margin-top: 0; /* keep spacing controlled by padding */\r\n}\r\n\r\n.supportItem:last-of-type {\r\n    padding-bottom: 0;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"leaveReviewIcon": `kEzlbZE8XlLEgVDD62Us ${___CSS_LOADER_ICSS_IMPORT_0___.locals["mapButtonIcon"]}`,
	"hidden": `Th5_rx7p1Klhq3wa9ELE`,
	"supportInfoContainer": `AGE2DgjFL9f4t36JwFGr ${___CSS_LOADER_ICSS_IMPORT_0___.locals["mapContentContainer"]}`,
	"supportHeaderContainer": `ObMsOZEvWpl64gpEUVmN ${___CSS_LOADER_ICSS_IMPORT_0___.locals["mapButtonHeaderContainer"]}`,
	"supportHeader": `QuTJH2RoH9JhAaU2tCbu ${___CSS_LOADER_ICSS_IMPORT_0___.locals["mapButtonHeader"]}`,
	"closeIcon": `CFzlBte8c0pPT6Hy8W2A ${___CSS_LOADER_ICSS_IMPORT_0___.locals["closeIcon"]}`,
	"supportInfoContentContainer": `Uggw6ndZQM1FN8r7TbLF ${___CSS_LOADER_ICSS_IMPORT_0___.locals["mapButtonContentContainer"]}`,
	"supportInfoContent": `neA44Gr8J0ZiFcI37grC ${___CSS_LOADER_ICSS_IMPORT_0___.locals["mapButtonContent"]}`,
	"supportItem": `LNoVV0vHVith5saxF5wX`,
	"supportItemsContainer": `aJUdQ_b3j1zIkrqmgLPw`
};
module.exports = ___CSS_LOADER_EXPORT___;
